import {
  ZIPCODE_FOR_DEMOGRAPHICS_RES,
  GET_PATIENT_BY_ID_FOR_DEMOGRAPHICS_RES,
  EDIT_AND_SAVE_PATIENT_DEMOGRAPHICS_RES,
  SEARCH_PAYER_INSURANCE_TAB_RES,
  SEARCH_PAYER_ADDRESS_INSURANCE_TAB_RES,
  CLEAR_HEADER,
  GET_POLICIES_BY_PATIENTID_DEMOGRAPHICS_RES,
  GET_POLICIY_HOLDER_BY_PATIENT_ID_INSURANCE_TAB_RES,
  EDIT_SAVE_INSURANCE_TAB_RES,
  STATUS_CHANGE_OF_INSURNACE_RES,
  CURRENT_TAB_VALUE,
  GET_NOTES_FOR_ACCOUNTS_BY_PATIENT_ID_RES,
  SAVE_NOTES_FOR_ACCOUNTS_BY_PATIENT_ID_RES,
  GET_NOTES_FOR_APPOINTMENT_RES,
  SAVE_NOTES_FOR_APPOINTMENT_RES,
  GET_APPOINTMENT_LIST_RES_ACCOUNTS,
  CANCEL_APPOINTMENT_LIST_RES_ACCOUNTS,
  GET_ACCOUNTS_RES,
  CLAIM_LIST_RES,
  CLAIM_DOWNLOAD_RES,
  SAVE_PAYMENTS_RES,
  SAVE_CHARGE_RES,
  WRITEOFF_RES,
  PAYMENT_LIST_RES,
  BALANCE_LIST_RES,
  STATEMENT_LIST_RES,
  AUTHORIZATIONS_RES,
  PAYMENT_DELETE_RES,
  STRIPE_PAYMENT_RES,
  STATEMENT_DETAILS_RES,
  GET_PIN_RES,
  GET_CLAIM_NOTES_RES,
  RESET_WRITEOFF_RES,
  FETCH_MESSAGES_REQUEST,
  FETCH_MESSAGES_SUCCESS,
  GET_CHANNEL_PREFERENCES_SUCCESS,
  UPDATE_CHANNEL_PREFERENCES_SUCCESS,
  RESET_UPDATE_CHANNEL_PREFERENCES_RES,
  RESET_CHANNEL_PREFERENCES,
  RESET_STRIPE_PAYMENT_RES,
  BULK_WRITEOFF_RES,
  RESET_BULK_WRITEOFF_RES,
  GET_PATIENT_ADJUSTMENTS_RES,
  UNDO_WRITEOFF_RES,
  RESET_UNDO_WRITEOFF_RES,
} from './accounts.types'

const INITIAL_STATE = {
  demographicsZipData: {},
  PatientList: [],
  paymentDetailsAccounts: {},
  getpaymentByIdDataAccounts: {},
  deletePaymentDetailsAccounts: {},
  paymentDetail: {},
  editPaymentDetails: {},
  getpaymentByApptIdData: {},
  PatientDetilsDemographics: null,
  updatedPatientDetailsDemographics: null,
  clearHeader: false,
  patientPolicyDetails: {},
  policyHolderListInsurnaceTab: {},
  editSavedInsuranceRes: {},
  statusUpdatedResponse: null,
  currentTabValue: {},
  patientNotesListInAccounts: {},
  savePatientNotesResInAccounts: {},
  appointmentNotesList: {},
  saveAppointmentNotesRes: {},
  appointmentList: {},
  appointmentCancelStatus: {},
  insuranceTabSearchPayerAddressRes: null,
  insuranceTabSearchPayerRes: null,
  accountsInfo: null,
  claimList: null,
  claimFile: null,
  paymentList: null,
  paymentRes: null,
  writeoffres: null,
  balanceList: null,
  statementList: null,
  authorizationList: null,
  deletePayment: null,
  stripeResponse: null,
  statementDetailRes: null,
  patientPinRes: null,
  claimsNotesList: {},
  loading: false,
  msg: [],
  page: 0,
  size: 10,
  totalElements: 0,
  error: null,
  channelPreferences: null,
  updateChannelPreferencesRes: null,
  bulkWriteOffRes: null,
  patientAdjustments: null,
  undoWriteOffRes: null,
}

const accountsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ZIPCODE_FOR_DEMOGRAPHICS_RES: {
      return {
        ...state,
        ...{ demographicsZipData: action.payload },
      }
    }
    case GET_PATIENT_BY_ID_FOR_DEMOGRAPHICS_RES: {
      return { ...state, ...{ PatientDetilsDemographics: action.payload } }
    }
    case EDIT_AND_SAVE_PATIENT_DEMOGRAPHICS_RES: {
      return {
        ...state,
        ...{ updatedPatientDetailsDemographics: action.payload },
      }
    }
    case GET_ACCOUNTS_RES: {
      return {
        ...state,
        ...{ accountsInfo: action.payload },
      }
    }
    case CLAIM_LIST_RES: {
      return {
        ...state,
        ...{ claimList: action.payload },
      }
    }
    case CLAIM_DOWNLOAD_RES: {
      return {
        ...state,
        ...{ claimFile: action.payload },
      }
    }
    case WRITEOFF_RES: {
      return {
        ...state,
        ...{ writeoffres: action.payload },
      }
    }
    case RESET_WRITEOFF_RES: {
      return {
        ...state,
        writeoffres: null,
      }
    }
    case PAYMENT_LIST_RES: {
      return {
        ...state,
        ...{ paymentList: action.payload },
      }
    }
    case SAVE_CHARGE_RES: {
      return {
        ...state,
        ...{ chargeRes: action.payload },
      }
    }
    case SAVE_PAYMENTS_RES: {
      return {
        ...state,
        ...{ paymentRes: action.payload },
      }
    }
    case BALANCE_LIST_RES: {
      return {
        ...state,
        ...{ balanceList: action.payload },
      }
    }
    case STATEMENT_LIST_RES: {
      return {
        ...state,
        ...{ statementList: action.payload },
      }
    }
    case STATEMENT_DETAILS_RES: {
      return {
        ...state,
        ...{ statementDetailRes: action.payload },
      }
    }
    case AUTHORIZATIONS_RES: {
      return {
        ...state,
        ...{ authorizationList: action.payload },
      }
    }
    case PAYMENT_DELETE_RES: {
      // get id of deleted payment
      const deletedId = action.payload?.response?.data?.id

      // update payment list by filtering out deleted payment
      const updatedPaymentList = state.paymentList?.response?.data
        ? {
          ...state.paymentList,
          response: {
            ...state.paymentList.response,
            data: state.paymentList.response.data.filter(
              (item) => item.paymentId !== deletedId
            ),
          },
        }
        : state.paymentList

      // update state with new payment list and deleted payment info
      const newState = {
        ...state,
        deletePayment: action.payload,
        paymentList: updatedPaymentList,
      }

      return newState
    }
    case SEARCH_PAYER_INSURANCE_TAB_RES: {
      return {
        ...state,
        ...{ insuranceTabSearchPayerRes: action.payload },
      }
    }
    case SEARCH_PAYER_ADDRESS_INSURANCE_TAB_RES: {
      return {
        ...state,
        ...{ insuranceTabSearchPayerAddressRes: action.payload },
      }
    }
    case CLEAR_HEADER: {
      return {
        ...state,
        ...{ clearHeader: action.payload },
      }
    }
    case GET_POLICIES_BY_PATIENTID_DEMOGRAPHICS_RES: {
      return {
        ...state,
        ...{ patientPolicyDetails: action.payload },
      }
    }
    case GET_POLICIY_HOLDER_BY_PATIENT_ID_INSURANCE_TAB_RES: {
      return {
        ...state,
        ...{ policyHolderListInsurnaceTab: action.payload },
      }
    }

    case EDIT_SAVE_INSURANCE_TAB_RES: {
      return {
        ...state,
        ...{ editSavedInsuranceRes: action.payload },
      }
    }
    case STATUS_CHANGE_OF_INSURNACE_RES: {
      return {
        ...state,
        ...{ statusUpdatedResponse: action.payload },
      }
    }

    case CURRENT_TAB_VALUE: {
      return {
        ...state,
        ...{ currentTabValue: action.payload },
      }
    }
    case GET_NOTES_FOR_ACCOUNTS_BY_PATIENT_ID_RES: {
      return {
        ...state,
        ...{ patientNotesListInAccounts: action.payload },
      }
    }
    case SAVE_NOTES_FOR_ACCOUNTS_BY_PATIENT_ID_RES: {
      return {
        ...state,
        ...{ savePatientNotesResInAccounts: action.payload },
      }
    }

    case GET_NOTES_FOR_APPOINTMENT_RES: {
      return {
        ...state,
        ...{ appointmentNotesList: action.payload },
      }
    }

    case SAVE_NOTES_FOR_APPOINTMENT_RES: {
      return {
        ...state,
        ...{ saveAppointmentNotesRes: action.payload },
      }
    }

    case GET_APPOINTMENT_LIST_RES_ACCOUNTS: {
      return { ...state, ...{ appointmentList: action.payload } }
    }
    case CANCEL_APPOINTMENT_LIST_RES_ACCOUNTS: {
      return { ...state, ...{ appointmentCancelStatus: action.payload } }
    }
    case STRIPE_PAYMENT_RES: {
      return { ...state, ...{ stripeResponse: action.payload } }
    }
    case GET_PIN_RES: {
      return { ...state, ...{ patientPinRes: action.payload } }
    }
    case GET_CLAIM_NOTES_RES: {
      return { ...state, ...{ claimsNotesList: action.payload } }
    }
    case FETCH_MESSAGES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case FETCH_MESSAGES_SUCCESS: {
      const payload = action?.payload
      const msgList = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.content)
        ? payload.content
        : Array.isArray(payload?.data)
        ? payload.data
        : []
      return {
        ...state,
        loading: false,
        msg: msgList,
        totalElements: payload?.totalElements || msgList.length,
        page: payload?.pageable?.pageNumber ?? payload?.page ?? 0,
        size: payload?.pageable?.pageSize ?? payload?.size ?? 50,
      }
    }

    case GET_CHANNEL_PREFERENCES_SUCCESS:{
      return {
        ...state,
        ...{ channelPreferences: action.payload },
      }
    }
    case UPDATE_CHANNEL_PREFERENCES_SUCCESS: {
      return {
        ...state,
        updateChannelPreferencesRes: action.payload,
      }
    }
    case RESET_UPDATE_CHANNEL_PREFERENCES_RES: {
      return {
        ...state,
        updateChannelPreferencesRes: null,
      }
    }
    case RESET_CHANNEL_PREFERENCES: {
      return {
        ...state,
        channelPreferences: null,
      }
    }
    case RESET_STRIPE_PAYMENT_RES: {
      return {
        ...state,
        stripeResponse: null,
      }
    }
    case BULK_WRITEOFF_RES: {
      return { ...state, bulkWriteOffRes: action.payload }
    }
    case RESET_BULK_WRITEOFF_RES: {
      return { ...state, bulkWriteOffRes: null }
    }
    case GET_PATIENT_ADJUSTMENTS_RES: {
      return { ...state, patientAdjustments: action.payload }
    }
    case UNDO_WRITEOFF_RES: {
      return { ...state, undoWriteOffRes: action.payload }
    }
    case RESET_UNDO_WRITEOFF_RES: {
      return { ...state, undoWriteOffRes: null }
    }
    default:
      return state
  }
}
export default accountsReducer
